import { format } from "date-fns";
import { useModelState } from "@/utils/useModelState";
import { BookingPeriodConditionTypes } from "./BookingPeriodConditionTypes/BookingPeriodConditionType";

export function DateBookingPeriodConditionTypeComponent({ conditionType }: DateBookingPeriodConditionTypeComponentProps) {

    const [operator, setOperator] = useModelState(conditionType.operator);
    const [value, setValue] = useModelState(conditionType.value);

    return (
        <div className="flex flex-row gap-2">
            <div>
                <select className="form-control" value={operator} onChange={e => setOperator(e.target.value as BookingPeriodConditionTypes.DateComparisonOperator)}>
                    <option value="gt">&gt;</option>
                    <option value="gte">&gt;=</option>
                    <option value="lt">&lt;</option>
                    <option value="lte">&lt;=</option>
                    <option value="eq">=</option>
                    <option value="neq">!=</option>
                </select>
            </div>
            <div>
                <input className="form-control" type="date" value={format(value, "yyyy-MM-dd")} onChange={e => setValue(new Date(e.target.value))} />
            </div>
        </div>
    );
}

export interface DateBookingPeriodConditionTypeComponentProps {
    conditionType: BookingPeriodConditionTypes.DateBookingPeriodConditionType;
}